<template>
	<popup  title="Are you sure you want to stop your subscription?" @close="$emit('close')">
		<template v-slot:content>
			<div>
				<p>Having any issues? <a style="color: royalblue" @click="openIntercom"><b>Click here</b></a> to let us know, we will be happy to help.</p>
			</div>
		</template>

		<template v-slot:actions>
			<v-button :loading="loading" red border label="Stop subscription" @click="stop" />
			<v-button label="Cancel" @click="$emit('close')" />
		</template>
	</popup>
</template>

<script>
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";
import API from '@/api';


export default {
name: "cancel-subscription-popup",
	components: {VButton, Popup},
	mixins:[API],

	data() {
		return {
			loading: false,

		}
	},
	methods: {
		openIntercom(){
			window.Intercom("showNewMessage", "I'm canceling my account due to these issues: \n");
		},
		async track() {
			try {
				this.$gtag.event("canceled", {
					'event_category': "method",
					'event_label': "",
				});
			}catch {}
		},
		async stop() {
			try {
				this.loading = true;
				let newSub = await this.api.billing.cancelSubscription();
				this.track();
				this.$emit('stop', newSub);
			} catch (e) {
				console.error(e);
				this.$notify({
					group: 'main',
					title: "Something went wrong! try again in a bit, do let us know if this problem persists.",
					type: 'error',
				});
			} finally {
				this.loading = false;
			}
		}
	}
}
</script>

<style lang="scss" scoped>

</style>
